// src/components/shared/AndroidInstallGuide.js
// Guide d'installation Android - téléchargement APK + étapes simples

import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../hooks/useTheme';
import { APP_CONFIG } from '../../constants/config';

const AndroidInstallGuide = ({ open, onClose }) => {
  const { t } = useTranslation();
  const { theme } = useTheme();

  if (!open) return null;

  const handleDownload = () => {
    window.location.href = APP_CONFIG.APK_DOWNLOAD_URL;
  };

  const steps = [
    { icon: '📂', text: t('getApp.android.step1') },
    { icon: '⚙️', text: t('getApp.android.step2') },
    { icon: '📲', text: t('getApp.android.step3') },
    { icon: '✅', text: t('getApp.android.step4') },
  ];

  const styles = {
    overlay: {
      position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.55)', zIndex: 2000,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px',
      animation: 'fadeInOverlayA 200ms ease-out',
    },
    modal: {
      width: '100%', maxWidth: '420px', backgroundColor: theme.bg, borderRadius: '20px',
      padding: '24px 20px calc(env(safe-area-inset-bottom, 0px) + 20px)', maxHeight: '85vh', overflowY: 'auto',
      boxSizing: 'border-box', animation: 'popInModal 240ms cubic-bezier(0.32, 0.72, 0, 1)',
    },
    headerRow: { display: 'flex', justifyContent: 'flex-end', marginBottom: '4px' },
    closeBtn: { background: 'none', border: 'none', color: theme.textSecondary, fontSize: '20px', cursor: 'pointer' },
    iconCircle: {
      width: '64px', height: '64px', borderRadius: '18px', backgroundColor: theme.goldSoft,
      display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '28px', margin: '0 auto 16px',
    },
    title: { fontSize: '19px', fontWeight: '700', color: theme.textPrimary, textAlign: 'center', marginBottom: '6px' },
    subtitle: { fontSize: '13px', color: theme.textSecondary, textAlign: 'center', lineHeight: '1.5', marginBottom: '20px' },
    downloadBtn: {
      width: '100%', padding: '15px', backgroundColor: theme.gold, border: 'none', borderRadius: '12px',
      color: '#FFFFFF', fontSize: '15px', fontWeight: '700', cursor: 'pointer', marginBottom: '22px',
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
      animation: 'downloadPulse 2.4s ease-in-out infinite',
    },
    stepsTitle: { fontSize: '12px', fontWeight: '700', color: theme.textMuted, textTransform: 'uppercase', letterSpacing: '0.4px', marginBottom: '10px' },
    stepRow: { display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 0' },
    stepIconBox: {
      width: '34px', height: '34px', borderRadius: '10px', backgroundColor: theme.bgCard,
      border: `1px solid ${theme.border}`, display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontSize: '16px', flexShrink: 0,
    },
    stepText: { fontSize: '13px', color: theme.textPrimary, lineHeight: '1.4' },
    closeBtnBottom: {
      width: '100%', padding: '13px', backgroundColor: 'transparent', border: `1px solid ${theme.border}`,
      borderRadius: '12px', color: theme.textSecondary, fontSize: '14px', fontWeight: '600', cursor: 'pointer', marginTop: '18px',
    },
  };

  return (
    <div style={styles.overlay} onClick={onClose}>
      <style>{`
        @keyframes fadeInOverlayA { from { opacity: 0; } to { opacity: 1; } }
        @keyframes popInModal { from { transform: scale(0.92); opacity: 0; } to { transform: scale(1); opacity: 1; } }
        @keyframes downloadPulse { 0%, 100% { box-shadow: 0 0 0 0 rgba(255,215,0,0.35); } 50% { box-shadow: 0 0 0 8px rgba(255,215,0,0); } }
      `}</style>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={styles.headerRow}>
          <button style={styles.closeBtn} onClick={onClose}>✕</button>
        </div>

        <div style={styles.iconCircle}>🤖</div>
        <div style={styles.title}>{t('getApp.android.title')}</div>
        <div style={styles.subtitle}>{t('getApp.android.subtitle')}</div>

        <button style={styles.downloadBtn} onClick={handleDownload}>
          ⬇️ {t('getApp.android.downloadButton')}
        </button>

        <div style={styles.stepsTitle}>{t('getApp.android.stepsTitle')}</div>
        {steps.map((s, index) => (
          <div key={index} style={styles.stepRow}>
            <div style={styles.stepIconBox}>{s.icon}</div>
            <div style={styles.stepText}>{s.text}</div>
          </div>
        ))}

        <button style={styles.closeBtnBottom} onClick={onClose}>{t('common.close')}</button>
      </div>
    </div>
  );
};

export default AndroidInstallGuide;